/**
 * This file used in santa-editor
 *
 * https://github.com/wix-private/santa-editor/blob/master/santa-editor/packages/styles/index.ts
 */
import {
  LegacySkinData,
  LegacySkinParamData,
  ParamName,
  SkinName,
} from '../skins';

import baseSkinCustomizations from './skins.json';

export const getDataSkinCustomizations = () => {
  let componentEditorParams = JSON.parse(
    JSON.stringify(baseSkinCustomizations),
  ) as Record<SkinName, LegacySkinData>;

  const labelSkinDataCustomizationParams: Record<
    ParamName,
    LegacySkinParamData
  > = {
    fntlbl: {
      state: 'regular',
      category: 'text',
      label: 'CustomDesign_Text_Font',
      section: 'label',
      priority: '1',
    },
    txtlbl: {
      state: 'regular',
      category: 'text',
      label: 'CustomDesign_Text_LabelTextColor',
      section: 'label',
      priority: '1',
    },
    txtlblrq: {
      state: 'regular',
      category: 'text',
      label: 'CustomDesign_Text_RequiredTextColor&Opacity',
      section: 'label',
      priority: '1',
    },
  };

  const labelSkinDataCustomizationSections = {
    label: {
      label: 'CustomDesign_Input_Label_Section',
      priority: 1,
    },
  };

  componentEditorParams = {
    ...componentEditorParams,
    ...[
      'wixui.skins.SelectionTagsList',
      'wixui.skins.RichTextBox',
      'wixui.skins.Rating',
    ].reduce<Record<SkinName, LegacySkinData>>(
      (acc, changedSkin) => ({
        ...acc,
        [changedSkin]: {
          params: {
            ...labelSkinDataCustomizationParams,
            ...(componentEditorParams?.[changedSkin]?.params ?? {}),
          },
          sections: {
            ...labelSkinDataCustomizationSections,
            ...(componentEditorParams?.[changedSkin]?.sections ?? {}),
          },
        },
      }),
      {},
    ),
    ...['wixui.skins.Slider'].reduce<Record<SkinName, LegacySkinData>>(
      (acc, changedSkin) => ({
        ...acc,
        [changedSkin]: {
          params: {
            fntlbl: labelSkinDataCustomizationParams.fntlbl,
            txtlbl: labelSkinDataCustomizationParams.txtlbl,
            ...(componentEditorParams?.[changedSkin]?.params ?? {}),
          },
          sections: {
            ...labelSkinDataCustomizationSections,
            ...(componentEditorParams?.[changedSkin]?.sections ?? {}),
          },
        },
      }),
      {},
    ),
    ...['wixui.skins.ToggleSwitch'].reduce<Record<SkinName, LegacySkinData>>(
      (acc, changedSkin) => ({
        ...acc,
        [changedSkin]: {
          params: {
            ...(componentEditorParams?.[changedSkin]?.params ?? {}),
            fntlbl: {
              ...labelSkinDataCustomizationParams.fntlbl,
              compPart: 'on',
            },
            txtlbl: {
              ...labelSkinDataCustomizationParams.txtlbl,
              compPart: 'on',
            },
          },
          sections: {
            ...labelSkinDataCustomizationSections,
            ...(componentEditorParams?.[changedSkin]?.sections ?? {}),
          },
        },
      }),
      {},
    ),
    'wixui.skins.ResponsiveSearchBox': {
      params: {
        inputBackgroundColor: {
          state: 'regular',
          category: 'fill',
          label: 'CustomDesign_FillColor_BGColor&Opacity',
          priority: 1,
          section: 'input',
        },
        inputIconColor: {
          state: 'regular',
          category: 'fill',
          label: 'CustomDesign_FillColor_Icon',
          priority: 2,
          section: 'input',
        },
        buttonBackgroundColor: {
          state: 'regular',
          category: 'fill',
          label: 'CustomDesign_FillColor_BGColor&Opacity',
          priority: 3,
          section: 'button',
        },
        buttonIconColor: {
          state: 'regular',
          category: 'fill',
          label: 'CustomDesign_FillColor_Icon',
          priority: 4,
          section: 'button',
        },
        inputTextColor: {
          state: 'regular',
          category: 'text',
          priority: 2,
          label: 'CustomDesign_SiteSearch_Text_TextColor',
        },
        inputPlaceholderColor: {
          state: 'regular',
          category: 'text',
          priority: 1,
          label: 'CustomDesign_InputControls_Placeholder_Text_Color',
        },
        inputFont: {
          state: 'regular',
          category: 'text',
          label: 'CustomDesign_TabLabel_Text',
          priority: 3,
          min: 6,
          max: 100,
        },
        inputBorderColor: {
          state: 'regular',
          category: 'border',
          label: 'CustomDesign_Border_Opacity&Color',
        },
        inputBorderWidth: {
          state: 'regular',
          category: 'border',
          label: 'CustomDesign_Border_Width',
        },
        inputBorderRadius: {
          state: 'regular',
          category: 'corners',
          label: 'CustomDesign_Corners_CornersRadius',
        },
        inputShadow: {
          state: 'regular',
          category: 'shadow',
          label: 'CustomDesign_TabLabel_Shadow',
        },
        inputHoverBackgroundColor: {
          state: 'hover',
          category: 'fill',
          label: 'CustomDesign_FillColor_BGColor&Opacity',
          section: 'input',
        },
        inputHoverIconColor: {
          state: 'hover',
          category: 'fill',
          label: 'CustomDesign_FillColor_Icon',
          section: 'input',
        },
        buttonHoverBackgroundColor: {
          state: 'hover',
          category: 'fill',
          label: 'CustomDesign_FillColor_BGColor&Opacity',
          section: 'button',
        },
        buttonHoverIconColor: {
          state: 'hover',
          category: 'fill',
          label: 'CustomDesign_FillColor_Icon',
          section: 'button',
        },
        inputHoverBorderColor: {
          state: 'hover',
          category: 'border',
          label: 'CustomDesign_Borders_Color&Opacity',
        },
        inputHoverBorderWidth: {
          state: 'hover',
          category: 'border',
          label: 'CustomDesign_Border_Width',
        },
        inputFocusBackgroundColor: {
          state: 'focus',
          category: 'fill',
          label: 'CustomDesign_FillColor_BGColor&Opacity',
          section: 'input',
        },
        inputFocusIconColor: {
          state: 'focus',
          category: 'fill',
          label: 'CustomDesign_FillColor_Icon',
          section: 'input',
        },
        buttonFocusBackgroundColor: {
          state: 'focus',
          category: 'fill',
          label: 'CustomDesign_FillColor_BGColor&Opacity',
          section: 'button',
        },
        buttonFocusIconColor: {
          state: 'focus',
          category: 'fill',
          label: 'CustomDesign_FillColor_Icon',
          section: 'button',
        },
        inputFocusBorderColor: {
          state: 'focus',
          category: 'border',
          label: 'CustomDesign_Borders_Color&Opacity',
        },
        inputFocusBorderWidth: {
          state: 'focus',
          category: 'border',
          label: 'CustomDesign_Border_Width',
        },
        suggestionSectionDividerColorNew: {
          hide: true,
        },
      },
      sections: {
        input: {
          label: 'CustomDesign_FillColor_Input_Field_Section_Title',
          priority: 1,
        },
        button: {
          label: 'CustomDesign_FillColor_Button_Section_Title',
          priority: 2,
        },
      },
    },
  };
  return componentEditorParams;
};
